import ModuleBase, { bindButtonClickEvent, moduleInit, implementFunction } from "../../../../framework/core/mvvm/module_base";
import HallView from "./hall_view";
import AppData from "../../../public/const/app_data";
import ModelData, { IUserData } from '../../../public/model_data';
import ModuleManager from '../../../../framework/core/module_manager';
import Setting from '../setting/setting';
import PlayerIconModule from "../playericon/playerIcon";
import EventManager from "../../../../manager/event_manager";
import { GameManager } from "../../../../manager/game_manager";
import LoaclStorage from '../../../../manager/local_storage';
import Customer from "../customer/customer";
import Activity from "../activity/activity";
import Promote from "../promote/promote";
import MailModule from "../mail/mail";
import { NotifyData } from "../../../public/notify_data";
import Rule from "../rule/rule";
import TimeManager from '../../../../manager/time_manager';
import AppController from "../../../../sdk/app_controller";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";
import ActivityUtil from "../activity/activity_util";
import Utility from "../../../../utility/utility";
import GoogleBillingController from "../../../../sdk/googlebilling_controller";
import DailySign from "../dailysign/dailysign";
import FirstCharge from "../firstcharge/firstcharge";
import { AutoDialogManager } from "../../../../manager/auto_dialog_manager";
import PromiseUtility from "../../../../utility/promiseUtility";
import { TaskModule } from "../gametask/task_module";
import { TaskHelp } from "../gametask/task_help";
import Chat from "../chat/chat";
import IAPController from "../../../../sdk/iap_controller";
import FriendModule from "../friend/friend_module";
import ClubList from "../../../club/clubList/clubList";
import { chat_data } from "../chat/chat_data";
import { joinUtil } from "../../../public/join_util";
import Shop from "../shop/shop";
import VideoReward from "../videoreward/videoreward";
import { friend_utils } from "../friend/friend_utils";
import { DayWelFareModule } from "../daywelfare/day_welfare_module";
import Bag from "../bag/bag";
import { QuickBuy } from "../quickbuy/quick_buy";
import ShareManager, { ShareCode } from "../../../../manager/share_manager";
import PlayerInfoSetting from "../playerInfoSetting/player_info_setting";
const { ccclass, menu } = cc._decorator;


@ccclass
@menu("package/hall/hall/hall")
@moduleInit("Hall")
export default class Hall extends ModuleBase<HallView, null> {
    mGameList = null;
    release = false
    lastOpenGoldEntraceModuleName: string = null
    lastOpenGoldEntraceModuleNum = 0
    lastOpenGoldEntraceModuleTime = 0
    maxLanHet = 0;
    protected m_refresh_money_schedule_id: number = 0


    constructor() {
        super();
        this.windowPrefabResPath = "package/hall/module/hall/hall_hall";
        this.viewType = HallView;
    }

    onModuleInit() {
        let self = this
        this.eventBind("hall_show_type", (data, inverted) => {
            if (self.view) {
                self.view.tweenTo(data, inverted)
            }
        })


    }

    on_destroy() {
        super.on_destroy()
        TimeManager.instance.cancelSchedule(this.m_refresh_money_schedule_id)
        chat_data.reset()
    }

    onShow(intentData) {
        GameManager.reportConversionEvent("login_enterHall", 1)
        ++this.lastOpenGoldEntraceModuleNum
        // ModuleManager.instance.setModuleActive("HallBase", true)
        this.showLayerTop()
        this.getSelfCurrencyData(null);
        this.getSelfUserData(null, true);
        if (AppData.showHall) {
            EventManager.instance.dispatch("hall_show_type", "LoginToHall")
        }
        AppData.showHall = true
        ModelData.instance.clubId = 0;
        if (intentData != "OpenFromGoldEntranceModule") {
            this.eventDispatch('Event_Notify_RedPoint')
            //TaskHelp.checkIsCanReceive(null,this);
        }

        this.checkAutoNotice()
        GameManager.getVersionConfigData()
        NotifyData.instance.changePlayerPos('hall');
        this.showNetPrompt(false)
        this.recheckOrder()
        TimeManager.instance.initServerTime()

        this.refresh_recent_chat(chat_data.recentChatData);
        this.requestFriendRed();
        this.requestWelfareActivity()
        this.showShare()
        ModelData.instance.httpGetAppRemoteConfigData()
        NotifyData.instance.getBagData() //为了更新红点
        //暂时只在测试模式下注册
        AppData.testMode && AppController.instance.registerForRemoteNotification()
        AppData.testMode && AppController.instance.getFirebaseMessageToken()
    }

    showShare() {
        let self = this
        ShareManager.getShareModuleList(function () {
            // ShareManager.showShareButton(self.view.shareBtn,ShareCode.Hall)
        })
    }

    protected checkAutoNotice() {
        let self = this
        let list = []
        let showGoldCurrency = true  //ModelData.instance.showGoldCurrency
        let checkDailySign = function (cb) {
            ActivityUtil.getDailySignData(function (data) {
                if (!ActivityUtil.hasOpenedToday('DailySign')) {
                    data && AutoDialogManager.pushUIQueue('DailySign', data)
                }
                cb()
            }, self)
        }
        showGoldCurrency && list.push(checkDailySign)

        let firstchargeFunc = (cb) => {
            ActivityUtil.isHaveFirstCharge((isHave) => {
                self.eventDispatch('refresh_firstCharge', isHave);
                if (!ActivityUtil.hasOpenedToday('FirstCharge')) {
                    isHave && AutoDialogManager.pushUIQueue('FirstCharge')
                }
                cb();
            }, self)
        }
        showGoldCurrency && list.push(firstchargeFunc)

        if (!AppData.startCheckGame) {
            let checkActiviyShow = function (cb) {
                ActivityUtil.needAutoShowActivity(function (needShow, dataList) {
                    needShow && AutoDialogManager.pushUIQueue('Activity', { noticeData: dataList })
                    cb()
                }, self)
            }
            list.push(checkActiviyShow)
        }



        PromiseUtility.sequence(list).then(function () {
            AutoDialogManager.openPriorityUI();
        })
    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(currencyData: IUserCurrencyData) {
        let self = this
        self.view.setCurrencyData(currencyData)
    }

    @implementFunction('onUserDataUpdate')
    protected on_userDataUpdate(data: IUserData) {
        let self = this
        self.view.setInfo(data)
    }

    onInit() {
        let self = this
        self.getUserData(ModelData.instance.roleData.id, (data: IUserData) => {
            self.view.setInfo(data)
        })
        //this.eventBind("event_refresh_user_bindingData",this.refreshBindingData);        
        this.eventBind('game_event_show', this.onApplicationShow)
        this.eventBind('refresh_firstCharge', this.refresh_firstCharge)
        this.eventBind("Event_Notify_Recent_Chat", this.refresh_recent_chat);
        this.eventBind("Event_New_Invite_Msg", this.on_new_invite_msg);
        this.view.moreNode.active = false;
    }


    recheckOrder() {
        if (CC_JSB) {
            if (cc.sys.os == cc.sys.OS_ANDROID) {
                GoogleBillingController.queryPurchasesInApp()
                GoogleBillingController.queryPurchasesSubs()
            } else if (cc.sys.os == cc.sys.OS_IOS) {
                IAPController.restorePurchase()
            }
        }
    }


    protected onButtonClickName(name: string) {
        //this.openGoleEntrance(name)
        joinUtil.openGoleEntrance(name);

    }

    @bindButtonClickEvent("ButtonShare")
    onButtonShare() {
        ShareManager.prepareShare(ShareCode.Hall)
    }
    @bindButtonClickEvent('quickbuyBtn')
    onQucikbuy() {
        // ModuleManager.instance.isNoAccessShowModule("QuickBuy", true,()=>{
        //     ModuleManager.instance.showModule<QuickBuy>(QuickBuy)
        // })
        ModuleManager.instance.showModule<QuickBuy>(QuickBuy)
    }

    @bindButtonClickEvent("ButtonSetting")
    onButtonSetting() {
        ModuleManager.instance.showModule<Setting>(Setting)
        this.view.moreNode.active = false

    }
    @bindButtonClickEvent("ButtonCustomer")
    onButtonCustomer() {
        cc.log("客服系统");
        ModuleManager.instance.showModule<Customer>(Customer, {
            "customerType": 1,
        })
        this.view.moreNode.active = false
    }


    @bindButtonClickEvent("ButtonChip")
    onButtonCurrencyChip() {
        ModuleManager.instance.showModule<Shop>(Shop, { tag: "tag_coin" })
    }

    @bindButtonClickEvent("ButtonDaiBi")
    onButtonCurrencyDaiBi() {
        ModuleManager.instance.showModule<Shop>(Shop, { tag: "tag_daibi" })
    }

    @bindButtonClickEvent("world_chat")
    onBtnChat() {
        ModuleManager.instance.showModule<Chat>(Chat)
    }

    @bindButtonClickEvent("btnMore")
    onbtnMore() {
        this.view.moreNode.active = true;
    }

    @bindButtonClickEvent("moreBtnBg")
    onmoreBtnBg() {
        this.view.moreNode.active = false;
    }

    @bindButtonClickEvent("btnTask")
    onButtonTask() {
        ModuleManager.instance.showModule<TaskModule>(TaskModule)
    }

    @bindButtonClickEvent("btnFriend")
    onButtonFriend() {
        // ModuleManager.instance.isNoAccessShowModule("FriendModule", true,()=>{
        //     ModuleManager.instance.showModule(FriendModule);

        //     this.view.showFriendRed(false);
        // })
        ModuleManager.instance.showModule(FriendModule);
        this.view.showFriendRed(false);
    }

    @bindButtonClickEvent("btnClub")
    onButtonClub() {
        let self = this;
        ModuleManager.instance.isNoAccessShowModule("ClubList", true, () => {
            ModuleManager.instance.showModule(ClubList, null, () => {
                self.hide();
                // ModuleManager.instance.hideModule("HallBase");
            });
        })



    }

    @bindButtonClickEvent("ButtonBag")
    onButtonBag() {
        ModuleManager.instance.showModule<Bag>(Bag, { tag: 'tag_daoju' })
    }

    @bindButtonClickEvent("buttonTG")
    onButtonPromote() {
        cc.log("全面推广系统");
        ModuleManager.instance.showModule<Promote>(Promote)
    }

    @bindButtonClickEvent("buttonFirstCharge")
    onButtonFirstCharge() {
        ModuleManager.instance.showModule<FirstCharge>(FirstCharge)
    }

    @bindButtonClickEvent("buttonFirstSign")
    onButtonSign() {
        ModuleManager.instance.showModule<DailySign>(DailySign)
    }

    @bindButtonClickEvent("ButtonMail")
    onButtonMail() {
        ModuleManager.instance.showModule<MailModule>(MailModule)
    }

    @bindButtonClickEvent("buttonGG")
    onButtonGG() {
        ModuleManager.instance.showModule<Activity>(Activity)
        // ModuleManager.instance.showModule<Activity>(Activity, {tag: 'activity', subTag: 'score', onlyOne: true})

    }

    @bindButtonClickEvent("ButtonQuick")
    onButtonQuick() {
        //this.openGoleEntrance(LoaclStorage.getString("LATELY_GAME", "TM_BP"))
        joinUtil.openGoleEntrance(LoaclStorage.getString("LATELY_GAME", "TM_BP"));

    }

    @bindButtonClickEvent("SpriteAvatar")
    onButtonPlayerHead() {
        //ModuleManager.instance.showModule<PlayerIconModule>(PlayerIconModule)
        ModuleManager.instance.showModule<PlayerInfoSetting>(PlayerInfoSetting)
    }

    @bindButtonClickEvent("ButtonMoveLeft")
    onButtonMoveLeft() {
        this.view.moveButton("left");
    }

    @bindButtonClickEvent("ButtonRule")
    onButtonRule() {
        ModuleManager.instance.showModule<Rule>(Rule, { isHall: true })
        this.view.moreNode.active = false
    }


    @bindButtonClickEvent("ButtonMoveRight")
    onButtonMoveRight() {
        this.view.moveButton("right");
    }

    @bindButtonClickEvent("ButtonADRewardGet")
    onADRewardGet() {
        ModuleManager.instance.showModule(VideoReward)
    }

    @bindButtonClickEvent('dayWelfareBtn')
    dayWelfareBtn() {
        ModuleManager.instance.showModule(DayWelFareModule)
    }

    @bindButtonClickEvent("Recharge")
    onRecharge() {

        // ModuleManager.instance.isNoAccessShowModule("Shop", true,()=>{
        //     Utility.reportEffect(`game_recharge_open`)
        //     ModuleManager.instance.showModule(Shop)
        //     this.recheckOrder()
        // })
        Utility.reportEffect(`game_recharge_open`)
        ModuleManager.instance.showModule(Shop)
        this.recheckOrder()
    }

    @bindButtonClickEvent("buttonFullScreen")
    btnFullScreen() {
    }


    callBackTip() {
        ModuleManager.instance.toastKey("public_NotBindingCellPhone");
    }

    protected onApplicationShow(show: boolean) {
        if (show) {
            if (!this.isHide) {
                this.getSelfUserData(null, true)
                this.getSelfCurrencyData(null, true)
            }
        }
    }

    refresh_firstCharge(isHave) {
        this.view.firstChargeNode.active = isHave //&& ModelData.instance.showGoldCurrency;
        this.view.qucikBuyBtn.active = !isHave
        if (!isHave) {//check 是否有快捷礼
            this.requestQuickBuy();
        }
    }


    private refresh_recent_chat(recentData: { type: number, name: string, content: string }) {

        if (AppData.startCheckGame) {
            this.view.chatChannels.forEach(element => {
                element.active = false;
                element.parent.active = false;
            });
        }
        else {
            this.view.updateRecentChat(recentData);
        }
    }

    private on_new_invite_msg() {

        this.view.showFriendRed(true);
    }

    private requestWelfareActivity() {
        TaskHelp.requestDayWelfare((data: any) => {
            this.view.updateDayWelfare(data);
        }, this);
    }

    private requestQuickBuy() {
        ActivityUtil.isHaveQuickBuy((isHave: boolean) => {
            this.view.qucikBuyBtn.active = isHave;
        }, this)
    }

    private requestFriendRed() {

        let self = this;
        friend_utils.getUnprocessedInvite(this, (result) => {
            self.view.showFriendRed(result);
        });
    }


}

